import { render, staticRenderFns } from "./users_table.vue?vue&type=template&id=1a6240ff&scoped=true&"
import script from "./users_table.vue?vue&type=script&lang=js&"
export * from "./users_table.vue?vue&type=script&lang=js&"
import style0 from "./users_table.vue?vue&type=style&index=0&id=1a6240ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6240ff",
  null
  
)

export default component.exports